import { render, staticRenderFns } from "./AbkSimpleMessagesNew.vue?vue&type=template&id=356aff17&scoped=true&"
import script from "./AbkSimpleMessagesNew.vue?vue&type=script&lang=js&"
export * from "./AbkSimpleMessagesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356aff17",
  null
  
)

export default component.exports